import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { StyledGrid } from '../styles';
import { Button } from '@mui/material';
import GradientCard from 'Core_Components/GradientCard/GradientCard';
import { appInsights } from 'Core_Helpers/AppInsights';
import { selectUserInfo, selectUserMeta } from 'Core_Redux/user';
import { useCoreSelector } from 'Contexts/StoreContext';
import hasPermissions from 'Core_Helpers/authentication/hasPermissions';
import filterUserMetaByTag from 'Core_Pages/MyTools/userMetaHelpers';
import urlcat from 'urlcat';
import { ToolTypes } from 'Core_Pages/MyTools/enumerations/enums';
import { MYTOOLS } from 'Core_Pages/Routes/RoutesConfig';
import { relationships } from 'Assets/img/my-tools-icons';
import { relationshipItems } from 'Core_Pages/MyTools/MyToolsPage/MyRelationshipTools/config';

function MyRelationshipsTile() {
  const history = useHistory();
  const intl = useIntl();
  const profile = useCoreSelector(selectUserInfo);
  const userMeta = useCoreSelector(selectUserMeta);

  function onToolClick() {
    appInsights.trackEvent({ name: 'MyTools_Relationships' });
    history.push(urlcat(MYTOOLS, { toolType: 'relationships' }));
  }

  const getLessonTotal = () => {
    return relationshipItems.filter(
      (x) => hasPermissions(x.permissions, x.roles, profile) && filterUserMetaByTag(x.contentCategory, userMeta),
    )?.length;
  };

  return (
    <StyledGrid mobile={12} tablet={6}>
      <Button onClick={onToolClick} fullWidth sx={{ padding: '0px' }}>
        <GradientCard
          titleId="home.tools.relationships"
          backgroundColor="#D9FCFF"
          icon={relationships}
          to={urlcat(MYTOOLS, { toolType: 'relationships' })}
          toolType={ToolTypes.RELATIONSHIPS}
          imageStyle={{ margin: '23px 15px' }}
          label={`${getLessonTotal()} ${intl.formatMessage({ id: 'home.tools.label' })}`}
        />
      </Button>
    </StyledGrid>
  );
}

export default MyRelationshipsTile;
